import styled from 'styled-components';

export const Container = styled.section`
  margin-top: 28px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 20px;
  }

  > p {
    margin: 44px auto 0px auto;
    max-width: 400px;
    text-align: center;
  }
`;

export const Description = styled.div`
  width: 100%;
  padding: 8px;
  text-align: center;
  margin-bottom: 44px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-bottom: 20px;
  }
`;

export const Top = styled.button`
  width: 100%;
  padding: 8px 20px;
  display: flex;
  align-items: center;
  border: 0;
  border-radius: 16px 16px 0 0;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.grey.white};
  color: ${({ theme }) => theme.colors.primary.main};

  svg {
    width: 32px;
    color: ${({ theme }) => theme.colors.primary.main};

    path {
      stroke-width: 2.5px;
    }
  }
`;

export const Grid = styled.div`
  width: 100%;
  display: ${({ $show }) => ($show ? 'flex' : 'none')};
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-top: 4px;
  }
`;

export const Box = styled.div`
  border-right: 1px solid rgba(256, 256, 256, 0.2);
  border-bottom: 1px solid rgba(256, 256, 256, 0.2);
  padding: 16px;
  color: ${({ theme }) => theme.colors.grey.white};
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  max-width: 33%;

  > div {
    width: 100%;
    display: flex;
    align-items: center;
  }

  small {
    font-size: 12px;
  }

  /* Remove borda direita da 3ª coluna */
  &:nth-child(3n) {
    border-right: none;
  }

  /* Remove borda inferior da última linha */
  &:nth-last-child(-n + 3) {
    border-bottom: none;
  }

  > div {
    display: flex;
    align-items: center;
    gap: 8px;

    .content {
      width: 16px;
      height: 16px;
      border: 1px solid ${({ theme }) => theme.colors.grey[100]};
      border-radius: 4px;
      background-color: transparent;
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    max-width: 50%;
    border-right: 0;

    &:nth-child(1n) {
      border-bottom: 1px solid rgba(256, 256, 256, 0.2);
    }

    &:nth-child(2n) {
      border-left: 1px solid rgba(256, 256, 256, 0.2);
      border-bottom: 1px solid rgba(256, 256, 256, 0.2);
    }
  }
`;

export const BoxText = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-right: 20px;

  > div {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 8px;

    &:nth-child(${({ $value }) => $value}) .content {
      background-color: ${({ theme }) => theme.colors.grey[100]};
    }

    .content {
      width: 16px;
      height: 16px;
      border: 1px solid ${({ theme }) => theme.colors.grey[100]};
      background-color: transparent;
      border-radius: 4px;
    }

    span {
      margin-bottom: -3px;
    }
  }
`;
